import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	gridNoMargin,
	resetFirstLastMargins,
	resetFirstChildMarginTop,
} from '@/css/resources/placeholders.css';
import {
	fontStyle,
	fluidMargin,
	fluidValues,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(fluidMargin(styles?.margin), {
		'.supt-form__fields': {
			marginBottom: styles?.error?.typography?.margin?.bottom,
		},

		'.supt-form__messages': {
			'.supt-form__messages__error': {
				'> p': fontStyle({
					...styles?.error?.typography,
					textAlign: styles?.error?.textAlignment,
					color: styles?.error?.color,
				}),
			},

			'.supt-form__messages__success': {
				'> p': fontStyle({
					...styles?.success?.typography,
					textAlign: styles?.success?.textAlignment,
					color: styles?.success?.color,
				}),
			},
		},
	});

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		'.supt-form__fields': cssObj(
			gridNoMargin,
			resetFirstChildMarginTop,
			fluidValues(
				'gridRowGap',
				styles?.input?.margin?.bottom[0],
				styles?.input?.margin?.bottom[1]
			)
		),

		'.supt-form__messages': {
			position: 'relative',

			'.supt-form__messages__error, .supt-form__messages__success': {
				position: 'absolute',
				left: '0',
				width: '100%',

				// '> p': cssObj(resetFirstLastMargins, {
				// 	maxWidth: '600px',
				// }),
			},
		},

		'.supt-form__actions': {
			display: 'flex',
			justifyContent: 'flex-end',

			'.supt-form__submit': cssObj(resetFirstLastMargins, {
				cursor: 'pointer',
				'&[disabled]': {
					opacity: 0.7,
					cursor: 'not-allowed',
				},
			}),
		},
	});

export { getStyles };
